export default "__VITE_ASSET__b4789bd7__"